import type { CancelToken } from 'axios'
import api from './api'

export interface PostRequestOptions {
  headers?: Record<string, string>
  cancelToken?: CancelToken
  onUploadProgress?: (event: ProgressEvent) => void
  signal?: AbortSignal
  timeout?: number
}

export default class PostRequest {
  url: string
  body: unknown
  options: PostRequestOptions

  constructor(url: string, body: unknown, options?: PostRequestOptions) {
    this.url = url
    this.body = body
    this.options = options ?? {}
  }

  async run<R>() {
    // Campos selecionados da config do Axios são expostos via PostRequestOptions.
    // Se novos campos forem necessários, adicionar tanto aqui quanto na interface PostRequestOptions.
    return api.post<R>(this.url, this.body, {
      headers: this.options.headers,
      cancelToken: this.options.cancelToken,
      onUploadProgress: this.options.onUploadProgress,
      signal: this.options.signal,
      timeout: this.options.timeout
    })
  }
}
